import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { NOT_FOUND } from 'redux-first-router'
import classNames from 'classnames'
import compose from 'recompose/compose'

// Loading vanilla components as we are going to provide the theme trough the props to speed up things
import Notification from '@/ui/Notification'
import Modal from '@/ui/Modal'
import AppBar from '@/ui/AppBar'
import Breadcrumbs from '@/ui/Breadcrumb/Breadcrumbs'
// import { TransitionGroup, Transition } from '@/ui/Transition'

import { goToPage as goToPageAction } from '@/state/actions/routes'
import { pageFlipStop } from '@/state/actions/pageflip'
import { getRouteType, getRoutesMap } from '@/state/selectors'

import themed from '@/ui/Theme/themed'

import TranslationProvider from '@/i18n/TranslationProvider'
import englishMessages from '@/i18n/messages'

const messages = {
  en: {
    ...englishMessages,
  },
}

class Container extends Component {
  // Avoid binding custom methods
  // This technique relies upon the proposed class property feature.
  // https://github.com/jeffmo/es-class-public-fields
  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextProps.pageflip.animated === this.props.pageflip.animated &&
      nextProps.location.pathname === this.props.location.pathname &&
      nextState === this.state
    ) {
      return false
    }
    return true
  }

  onEnter = () => {
    // Entering a new page
  }

  onLeave = () => {
    // Page has been removed
    const { dispatch } = this.props
    dispatch(pageFlipStop())
  }

  render() {
    const { route, routesMap, locale, user, theme, pageflip: { animated, dir } } = this.props // eslint-disable-line
    const curRouteData = routesMap[route]
    const Route = !!(curRouteData && curRouteData.view) // Make sure route exists and it has the view
      ? curRouteData.view
      : routesMap[routesMap[NOT_FOUND]].view

    return (
      <TranslationProvider messages={messages}>
        <main className={theme.app}>
          <If condition={!curRouteData.hidden}>
            <AppBar
              routesMap={routesMap}
              currentRouteType={route}
              user={user}
              theme={theme}
              dispatch={this.props.dispatch}
            />
          </If>
          <div className={classNames(theme.body, { [theme['no-scroll']]: animated })}>
            <div className={theme.wrap}>
              <If condition={!curRouteData.hidden}>
                <Breadcrumbs
                  theme={theme}
                  routesMap={routesMap}
                  route={route}
                  goToPage={this.props.goToPage}
                />
              </If>
              <div className={theme.switcher}>
                <Route
                  currentRouteType={route}
                  currentRouteData={curRouteData}
                  routesMap={routesMap}
                  dispatch={this.props.dispatch}
                  locale={locale}
                  theme={theme}
                />
              </div>
            </div>
          </div>
          <Modal theme={theme} />
          <Notification theme={theme} />
        </main>
      </TranslationProvider>
    )
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  locale: state.locale,
  location: state.location,
  route: getRouteType(state),
  routesMap: getRoutesMap(state),
  pageflip: state.ui.pageflip,
})

const mapDispatchToProps = dispatch => {
  return {
    goToPage: bindActionCreators(goToPageAction, dispatch),
    dispatch: dispatch,
  }
}

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), themed)
export default enhance(Container)



// WEBPACK FOOTER //
// ./view/Main/Main.js